<template>
  <HeaderEvent :event="event" :organizer_id="event.organizer.id" :organizer_slug="event.organizer.slug" :image="event.image"/>
  <div class="container-fluid body">
    <div class="container">
      <Loader :show="loading"/>
      <div class="row body-box body-evento">
        <div class="col-md-8">
          <h1 id="h1_titulo">{{event.name}}</h1>
          <ul>
            <li class="w50">
              <h4><span class="glyphicon glyphicon-stats glyphcolor4"></span> STATUS</h4>
              <h5 id="h5_status" v-html="text_status(event)"></h5>
              <h4><span class="glyphicon glyphicon-map-marker glyphcolor4"></span> LOCAL</h4>
              <h5 id="h5_local">{{ event.local == null ? 'Em Breve':event.local }}</h5>
              <h4><span class="glyphicon glyphicon-time glyphcolor4"></span> LARGADA</h4>
              <h5 id="h5_largada">{{ event.largada == null ? 'Em Breve':event.largada }}</h5>
              <h4><span class="glyphicon glyphicon-ok-circle glyphcolor4"></span> MODALIDADES</h4>
              <h5 id="h5_modalidades">{{modalidades}}</h5>
            </li>
            <li class="w50">
              <h4>FALTAM</h4>
              <Countdown  :end_time="event.subscription_end" :start_time="event.subscription_start"  />
              <h4></h4>
              <div class="btn-full">
                <div id="btn_insc" v-if="(new Date(event.subscription_end)) >= (new Date())">
                  <div class="col-xs-6 no-padding">
                    <v-link v-if="user_logged && lote" class="btn btn-success" width="100%" :href="'/escolha-o-kit/'+ event.id +'/'+ event.slug +'/'+hash+'/'+lote">Inscreva-se</v-link>
                    <v-link v-else-if="user_logged && lote== undefined" class="btn btn-success" width="100%" :href="'/escolha-o-kit/'+ event.id +'/'+ event.slug +'/'+hash">Inscreva-se</v-link>
                    <v-link v-else-if="lote== undefined" class="btn btn-success" width="100%" :href="'/inscricao/'+ event.id +'/'+ event.slug +'/'+hash">Inscreva-se</v-link>
                    <v-link v-else class="btn btn-success" width="100%" :href="'/inscricao/'+ event.id +'/'+ event.slug +'/'+hash+'/'+lote">Inscreva-se</v-link>
                  </div>
                  <div class="col-xs-6 no-padding">
                    <button type="button" class="btn btn-info" @click="show_regulamentos">Regulamento</button>
                  </div>
                </div>
                <div v-else-if="(new Date(event.subscription_end)) < (new Date())">
                  <div class="col-xs-12 no-padding">
                    <button type="button" class="btn btn-info" @click="show_regulamentos">Regulamento</button>
                  </div>
                </div>
                <h6 id="h5_data" class="text-center">Inscrições até {{ (new Date(event.subscription_end)).toLocaleString("pt-BR", {timeZone: "America/Sao_paulo"}) }} ou o término das vagas.</h6>
              </div>
            </li>
          </ul>
          <div id="div_conteudo">
            <div class="evento" v-if="event.description">
              <h2>Sobre o evento</h2>
              <p v-html="event.description"> </p>
            </div>
            <div class="kits" v-if="event.kits">
              <h2>Kits</h2>
              <p v-html="event.kits"> </p>
            </div>
            <div class="percurso" v-if="event.course">
              <h2>Percurso</h2>
              <p v-html="event.course"> </p>
            </div>
            <div class="awards" v-if="event.awards">
              <h2>Premiação</h2>
              <p v-html="event.awards"> </p>
            </div>
            <div class="complementary" v-if="event.complementary">
              <h2>Complementar</h2>
              <p v-html="event.complementary"> </p>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <p id="div_capa2">
            <img :src="event.image" class="capa-evento-view" :alt="event.name">
          </p>
          <div id="div_redes"></div>
          <h4>Evento organizado por:</h4>
          <p id="p_organizador">
            {{ event.organizer.razao_social }}
            <br>
            CNPJ: {{ event.organizer.cnpj }}
            <br>
            {{ event.organizer.telephone }}
          </p>
          <h6>As informações disponibilizadas nesta página, a organização do evento e a sua realização, são de responsabilidades do organizador. Para mais informações, leia nosso Termo de Uso.</h6>
          <div id="div_patrocinadores" v-if="event.sponsor.length">
            <h5><b>Patrocínio</b></h5>
            <p class="box-patrocinadores">
              <a :href="sponsorItem.link" target="_blank" v-for="(sponsorItem,index) in event.sponsor" :key="index">
                <img :src="sponsorItem.image" >
              </a>
            </p>
          </div>
          <p class="clear">&nbsp;</p>
          <FacebookSide/>
        </div>
        <Atalhos/>
      </div>
    </div>
  </div>

  <div class="modal fade in regulamentos" tabindex="-1" role="dialog" style="display: block;" v-if="modalregulation"  @click="modalregulation= false">
    <div class="modal-dialog  modal-lg" role="document">
      <div class="modal-content" @click.stop="">
        <div class="modal-header text-center">
          <button type="button" class="close" @click="modalregulation= false" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title">Regulamento</h4>
        </div>
        <div class="modal-body" v-html="regulation">
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div><!-- /.modal -->
  <div class="modal-backdrop fade in" v-if="modalregulation" ></div>

  <Newsletter/>
  <Footer/>
  <FooterEnd/>
</template>

<script>
import {defineComponent} from "vue";
import HeaderEvent from "../components/HeaderEvent";
import Footer from "../components/Footer.vue";
import FooterEnd from "../components/FooterEnd.vue";
import Newsletter from "../components/Newsletter.vue";
import Atalhos from "@/components/Atalhos";
import Events from "@/api/Events";
import FacebookSide from "@/components/FacebookSide.vue";
import Loader from "../components/Loader";
import VLink from "../components/VLink";
import Countdown from "../components/Countdown";
import Auth from "../api/Auth";

export default defineComponent({
  name: "RestritoPage",
  components: {
    VLink,
    HeaderEvent,
    Footer,
    FooterEnd,
    Newsletter,
    Atalhos,
    FacebookSide,
    Loader,
    Countdown
  },
  computed: {
    modalidades: function () {
      let modalidades = "";
      this.event.modalities.map((item)=>{
        modalidades = item.name +  ', ' + modalidades;
      })
      return modalidades;
    }
  },
  data() {
    return {
      modalregulation:false,
      regulation:"",
      hash:'',
      id:'',
      slug:'',
      lote:'',
      loading:false,
      "user_logged":false,
      event:{
        "id": 0,
        "subscription_end": "",
        "largada": "",
        "name": "",
        "slug": "",
        "local": "",
        "state": "",
        "city": "",
        "description": "",
        "kits": "",
        "course": "",
        "awards": "",
        "complementary":"",
        "organizer": {
          "id": 0,
          "razao_social": "",
          "slug": "",
          "cnpj": "",
          "telephone": ""
        },
        "modalities": [],
        "banners": [],
        "sponsor":[],
      },
    };
  },
  methods: {
      status(event){
        let today = new Date();
        let start_date = new Date(event.subscription_start);
        let end_date = new Date(event.subscription_end);
        if(start_date <= today && end_date >= today){
          return true;
        }else{
          return false;
        }
      },
    text_status(event){
      let today = new Date();
      let start_date = new Date(event.subscription_start);
      let end_date = new Date(event.subscription_end);
      if (start_date <= today)
      {
        if (end_date >= today)
          return  "<span class=\"text-success\">INSCRIÇÕES ABERTAS</span>";
        else
          return "<span class=\"text-danger\">INSCRIÇÕES ENCERRADAS</span>";
      }
      else
        return "<span class=\"text-warning\">INSCRIÇÕES EM BREVE</span>";

    },
    fetch_info(){
      Events.get_event(this.slug).then((request) => {
        if(request.status == 200){
          this.event = request.data;
          this.event.subscription_end = request.data.lot_end;
        } else {
          this.$router.push("/evento/nao-encontrado/");
        }
        this.loading = false;
      });
    },
    show_regulamentos(){
      if(this.regulation == ""){
        Events.get_regulamento(this.slug).then((request)=>{
          if(request.status == 200) {
            this.modalregulation = true;
            this.regulation = request.data.regulation;
          }
        });
      }else{
        this.modalregulation = true;
      }

    },
  },
  mounted() {
    this.id =  this.$route.params.id;
    this.slug =  this.$route.params.slug;

    this.lote = this.$route.params.lote;


    let MD5 = function(d){var r = M(V(Y(X(d),8*d.length)));return r.toLowerCase()};function M(d){for(var _,m="0123456789ABCDEF",f="",r=0;r<d.length;r++)_=d.charCodeAt(r),f+=m.charAt(_>>>4&15)+m.charAt(15&_);return f}function X(d){for(var _=Array(d.length>>2),m=0;m<_.length;m++)_[m]=0;for(m=0;m<8*d.length;m+=8)_[m>>5]|=(255&d.charCodeAt(m/8))<<m%32;return _}function V(d){for(var _="",m=0;m<32*d.length;m+=8)_+=String.fromCharCode(d[m>>5]>>>m%32&255);return _}function Y(d,_){d[_>>5]|=128<<_%32,d[14+(_+64>>>9<<4)]=_;for(var m=1732584193,f=-271733879,r=-1732584194,i=271733878,n=0;n<d.length;n+=16){var h=m,t=f,g=r,e=i;f=md5_ii(f=md5_ii(f=md5_ii(f=md5_ii(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_ff(f=md5_ff(f=md5_ff(f=md5_ff(f,r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+0],7,-680876936),f,r,d[n+1],12,-389564586),m,f,d[n+2],17,606105819),i,m,d[n+3],22,-1044525330),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+4],7,-176418897),f,r,d[n+5],12,1200080426),m,f,d[n+6],17,-1473231341),i,m,d[n+7],22,-45705983),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+8],7,1770035416),f,r,d[n+9],12,-1958414417),m,f,d[n+10],17,-42063),i,m,d[n+11],22,-1990404162),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+12],7,1804603682),f,r,d[n+13],12,-40341101),m,f,d[n+14],17,-1502002290),i,m,d[n+15],22,1236535329),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+1],5,-165796510),f,r,d[n+6],9,-1069501632),m,f,d[n+11],14,643717713),i,m,d[n+0],20,-373897302),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+5],5,-701558691),f,r,d[n+10],9,38016083),m,f,d[n+15],14,-660478335),i,m,d[n+4],20,-405537848),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+9],5,568446438),f,r,d[n+14],9,-1019803690),m,f,d[n+3],14,-187363961),i,m,d[n+8],20,1163531501),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+13],5,-1444681467),f,r,d[n+2],9,-51403784),m,f,d[n+7],14,1735328473),i,m,d[n+12],20,-1926607734),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+5],4,-378558),f,r,d[n+8],11,-2022574463),m,f,d[n+11],16,1839030562),i,m,d[n+14],23,-35309556),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+1],4,-1530992060),f,r,d[n+4],11,1272893353),m,f,d[n+7],16,-155497632),i,m,d[n+10],23,-1094730640),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+13],4,681279174),f,r,d[n+0],11,-358537222),m,f,d[n+3],16,-722521979),i,m,d[n+6],23,76029189),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+9],4,-640364487),f,r,d[n+12],11,-421815835),m,f,d[n+15],16,530742520),i,m,d[n+2],23,-995338651),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+0],6,-198630844),f,r,d[n+7],10,1126891415),m,f,d[n+14],15,-1416354905),i,m,d[n+5],21,-57434055),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+12],6,1700485571),f,r,d[n+3],10,-1894986606),m,f,d[n+10],15,-1051523),i,m,d[n+1],21,-2054922799),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+8],6,1873313359),f,r,d[n+15],10,-30611744),m,f,d[n+6],15,-1560198380),i,m,d[n+13],21,1309151649),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+4],6,-145523070),f,r,d[n+11],10,-1120210379),m,f,d[n+2],15,718787259),i,m,d[n+9],21,-343485551),m=safe_add(m,h),f=safe_add(f,t),r=safe_add(r,g),i=safe_add(i,e)}return Array(m,f,r,i)}function md5_cmn(d,_,m,f,r,i){return safe_add(bit_rol(safe_add(safe_add(_,d),safe_add(f,i)),r),m)}function md5_ff(d,_,m,f,r,i,n){return md5_cmn(_&m|~_&f,d,_,r,i,n)}function md5_gg(d,_,m,f,r,i,n){return md5_cmn(_&f|m&~f,d,_,r,i,n)}function md5_hh(d,_,m,f,r,i,n){return md5_cmn(_^m^f,d,_,r,i,n)}function md5_ii(d,_,m,f,r,i,n){return md5_cmn(m^(_|~f),d,_,r,i,n)}function safe_add(d,_){var m=(65535&d)+(65535&_);return(d>>16)+(_>>16)+(m>>16)<<16|65535&m}function bit_rol(d,_){return d<<_|d>>>32-_}

    let hash = MD5(this.id + this.slug)
    if(hash.slice(-8) == this.$route.params.hash){
      console.log('HASH VALIDADA');
    }else{
      this.$router.push("/evento/nao-encontrado/");
    }

    this.hash = this.$route.params.hash;

    if(Auth.token()){
      this.user_logged = true;
    }else{
      this.user_logged = false;
    }

    this.regulation = "";

    this.loading = true;
    this.fetch_info();
  },
  updated() {
    if(Auth.token()){
      this.user_logged = true;
    }else{
      this.user_logged = false;
    }

    if(this.slug != this.$route.params.slug){

      this.regulation = "";
      this.slug = this.$route.params.slug;
      this.loading = true;
      this.fetch_info();
    }
  }
});
</script>

<style scoped>
img.capa-evento-view{
  width: 100%;
}
.box-patrocinadores a {
  width: 100%;
}
.box-patrocinadores a img{
  width: 100%;
}
.modal-body {
  max-height: calc(100vh - 210px);
  overflow-y: auto;
}
.no-padding{

  padding-right: 0px;
  padding-left: 0px;
}
.body-box.body-evento .col-md-8{
  z-index: 100;
}

.body-box.body-evento  #div_capa2{
  z-index: 1;
}
</style>
